import { Text } from '@calm-web/design-system';

import { EmotionUtils, TopEmotion } from '@/utils/emotion-detector';

import { EmotionButton, EmotionGrid } from '../styles';

interface EmotionGridComponentProps {
	selectedEmotion: TopEmotion | null;
	onEmotionSelect: (emotion: TopEmotion) => void;
}

export default function EmotionGridComponent({
	selectedEmotion,
	onEmotionSelect,
}: EmotionGridComponentProps) {
	return (
		<EmotionGrid>
			{EmotionUtils.getAllEmotions().map(emotion => (
				<EmotionButton
					key={emotion}
					selected={selectedEmotion === emotion}
					onClick={() => onEmotionSelect(emotion)}
				>
					<Text el="span">{EmotionUtils.getEmotionEmoji(emotion)}</Text>
					<Text el="span">{emotion}</Text>
				</EmotionButton>
			))}
		</EmotionGrid>
	);
}
